{
    "ModalTitleMc": "Passer un appel",
    "ModalTitleTo": "Envoyer l'appel à",
    "ModalTitleMcc": "Transfert de l'enquête vers",
    "SubTitle": "Choisir le numéro de téléphone",
    "SelectLabel": "Numéro de téléphone",
    "SelectPlaceholder": "par exemple 01234567899",
    "SelectNoItems": "Numéro inconnu",
    "FooterHelp": "Aide",
    "FooterOk": "OK",
    "FooterClose": "Fermer",
    "CallTargetting_Description": "Sélectionnez un appareil de destination interne dans la liste ou saisissez manuellement le numéro de téléphone de destination.",
    "NAME": "CallTargetting"
}